var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"not-italic text-sm bg-current inline-flex justify-center items-center !w-7 rounded text-gray-400 dark:text-gray-600"},[_c('span',{staticClass:"text-white pb-0.5 uppercase"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.displayCode))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }